var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M12.9723 9.83727L0.269653 2.26705V15.8057C0.269653 17.0419 1.19326 18.0534 2.32211 18.0534H23.6287C24.7575 18.0534 25.6811 17.0419 25.6811 15.8057V2.41251L12.9723 9.83727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 9",
    d: "M12.9785 8.21619L25.3325 0.998639C24.9631 0.397542 24.3363 2.67029e-05 23.6287 2.67029e-05H2.32213C1.6574 2.67029e-05 1.06405 0.350988 0.688354 0.891827L12.9785 8.21619Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.619e02ad45db681f19485c4b3eda160c.svg";
export { ForwardRef as ReactComponent };